import { Box, Paper } from "@mui/material";
import type { ReactNode } from "react";
import { RESULT_SURFACE_BORDER } from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";
import { InsightPanelScrollBox } from "./InsightPanelScrollBox";

interface InsightWorkspaceFilterColumnProps {
  accentColor: string;
  hasActiveFilter: boolean;
  children: ReactNode;
}

export function InsightWorkspaceFilterColumn({
  accentColor,
  hasActiveFilter,
  children,
}: InsightWorkspaceFilterColumnProps) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        minWidth: 0,
        display: "flex",
        boxSizing: "border-box",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          borderRightWidth: hasActiveFilter ? RESULT_SURFACE_BORDER : 1,
          borderRightStyle: "solid",
          borderRightColor: hasActiveFilter ? accentColor : "divider",
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <InsightPanelScrollBox accentColor={accentColor}>{children}</InsightPanelScrollBox>
      </Paper>
    </Box>
  );
}
